<div *ngIf="isLoading()" class="overlay">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>